export enum PromotionBuyCoinConditionEnum {
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
  LESS_THAN = 'LESS_THAN',
}
